export enum RequiredActionStatus {
  Completed = 'completed',
  Dismissed = 'dismissed',
  New = 'new',
}
